'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.milliseconds;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/milliseconds.js
// module id = 698
// module chunks = 0